import React, { useEffect, useState } from 'react'
import { Ionicons, Feather } from '@expo/vector-icons'
import { View, Image, TouchableOpacity, Text, StatusBar, BackHandler, ActivityIndicator, Platform } from 'react-native'
import { isAndroid } from '../../utils/platformUtils'
import { useNavigation, useRoute } from '@react-navigation/native'
import { getConection, getData, THEME_COLOR_ALERT, useButtonDownloadContext, useTheme } from './context/HeaderContext'
import theme from '../../../theme'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { Notifications } from '../notifications/Notifications'
import { useNotificationStore } from '../../redux/zustand/notificationStore'
import { SearchView } from './SearchView'
import { downloadPdf, eventEmitter, isEntornoTesting } from '../../utils/functions.utils'
import { LinearGradient } from 'expo-linear-gradient'
import styles from './AppBarStyles'
import { AppBarTheme, AppGradientTheme } from '../../../themeConstants'
import { getLocation } from './context/LocationContext'
import mediaSingleton from '../../utils/mediaSingleton'
import { UserServices } from '../../../database/user.database'
import Constants from 'expo-constants'
import { useStatusBarColorStore } from '../../redux/zustand/statusBarColorStore'
import { useDataPendingSendStore } from '../../redux/zustand/dataPendingSendStore'
import { getLanguageFile } from '../../translations/i18n'
import { getAlert } from './context/AlertsContext'
import { useLiveProgressAlert } from '../../hooks/useLiveProgressAlert'
import { PERFORMANCE_MONITOR_ENABLED } from '../../config/config'
import * as FileSystem from 'expo-file-system/legacy'
import { useFooterApp } from '../../redux/zustand/footerAppStore'
import { CLIENTS_SLUGS } from '../../constants/slugs'

const languageFile = getLanguageFile()

const expoConfig = Constants.expoConfig || {}
const slug = expoConfig.slug || ''

const AppBar = () => {

    const { backgroundColor } = useTheme()
    const { setAlert } = getAlert()
    const { linkDownload } = useButtonDownloadContext()
    const { generateAlertText } = useLiveProgressAlert()

    const { without_seeing } = useNotificationStore()

    const navigation = useNavigation()
    const route = useRoute()
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const { isConnected, hasInternet } = getConection()
    const snapPoints = ['80%']
    const [secondaryStyle, setSecondaryStyle] = useState(false)
    const { footerRoute, customBack, prevFooterRoute, setCurrentFooterRoute } = getData()
    const { userLat, userLng, locationLoaded } = getLocation()
    const [buttonsNav, setButtons] = useState([])
    const setStatusBarColor = useStatusBarColorStore((store) => store.setStatusBarColor)
    const havePendingData = useDataPendingSendStore((store) => store.havePendingData)
    const setProgressTotalModal = useDataPendingSendStore((store) => store.setProgressTotalModal)
    const progressTotalModal = useDataPendingSendStore((store) => store.progressTotalModal)
    const showProfileNav = useFooterApp((state) => state.showProfileNav)
    const ROUTE_STYLES = {
        BenefitsHome: { secondary: false },
        Trivia: { secondary: false },
        TriviaGame: { secondary: true },
        Schedule: { secondary: true },
        StoreDetail: { secondary: true },
        ScheduleDistributor: { secondary: true },
        Ranking: { secondary: true },
        Profile: { secondary: false }, // Excepción explícita
        Survey: { hideNav: true },
        Gamification: { hideNav: true },
        TriviaGame: { hideNav: true },
    }

    const handle_notification = () => {
        openBottomSheet(<Notifications closeSearch={() => closeBottomSheet(true)} />, snapPoints, true, true, true, 'never', true)
    }

    const searchInTheApp = async () => {
        openBottomSheet(<SearchView closeSearch={() => closeBottomSheet(true)} />, snapPoints, true, true, true, 'never', true)
    }
    const goProfile = () => {
        navigation.navigate('Profile') // TODO: setear aca el nombre de la view que se quiere mostrar
    }

    const goDatabase = () => {
        navigation.navigate('DatabaseScreen') // TODO: setear aca el nombre de la view que se quiere mostrar
    }

    const get_info = async () => {
        try {
            const directory = FileSystem.documentDirectory
            console.log('🚀 ~ constget_info= ~ directory:', directory)

            const now = new Date()
            const offsetMinutes = now.getTimezoneOffset() // UTC offset en minutos (negativo = UTC+)
            const offsetHours = -(offsetMinutes / 60)
            console.log('===== DATE / TIMEZONE LOGS =====')
            console.log('>> Dispositivo')
            console.log('  timezone (IANA)    :', Intl.DateTimeFormat().resolvedOptions().timeZone)
            console.log('  UTC offset (hrs)   :', offsetHours >= 0 ? `+${offsetHours}` : `${offsetHours}`)
            console.log('  hora local (h)     :', now.getHours(), ':', now.getMinutes())
            console.log('  toLocaleString()   :', now.toLocaleString())
            console.log('>> UTC / Global')
            console.log('  toISOString()      :', now.toISOString())   // siempre UTC
            console.log('  getUTCHours()      :', now.getUTCHours(), ':', now.getUTCMinutes())
            console.log('  timestamp (ms)     :', Date.now())
            console.log('>> Por zona horaria')
            console.log('  Argentina (ART)    :', now.toLocaleString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' }))
            console.log('  México  (CST/CDT)  :', now.toLocaleString('es-MX', { timeZone: 'America/Mexico_City' }))
            console.log('  España  (CET/CEST) :', now.toLocaleString('es-ES', { timeZone: 'Europe/Madrid' }))
            console.log('  UTC                :', now.toLocaleString('en-US', { timeZone: 'UTC' }))
            console.log('=================================')

            let pendings = await UserServices.get_pendings_conections()
            console.log('pendings:', pendings)
            navigation.navigate('FormsAnswersScreen')
        } catch (error) {
            console.log('🚀 ~ constget_info= ~ error:', error)
        }
    }
    const handleDownloadLink = async () => {
        try {
            if (Platform.OS === 'web') {
                const url = linkDownload
                if (!url) return
                const getFileName = (inputUrl) => {
                    try {
                        const cleanUrl = inputUrl.split('?')[0]
                        const name = decodeURIComponent(cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1))
                        return name || 'archivo'
                    } catch (e) {
                        return 'archivo'
                    }
                }
                const fileName = getFileName(url)
                try {
                    const res = await fetch(url)
                    const blob = await res.blob()
                    const blobUrl = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = fileName
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    // Abrir en nueva pestaña también (opcional)
                    try {
                        window.open(blobUrl, '_blank', 'noopener')
                    } catch {}
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
                } catch (err) {
                    console.error('[AppBar] fetch blob failed, fallback to direct open', err)
                    window.open(url, '_blank', 'noopener,noreferrer')
                }
                return
            }
        } catch (err) {
            console.error('[AppBar] Descarga web falló, abriendo en nueva pestaña', err)
            try {
                window.open(linkDownload, '_blank', 'noopener,noreferrer')
            } catch {}
            return
        }
        downloadPdf(linkDownload)
    }

    const [showNav, setShowNav] = useState(true)

    useEffect(() => {
        if (!footerRoute) {
            return
        }
        setSecondaryStyle(findSecondaryStyle())
        handleButtonsUpdate()
    }, [footerRoute])

    const findSecondaryStyle = () => {
        return ROUTE_STYLES[footerRoute]?.secondary && route.name !== 'Profile'
    }
    const disableSwipeBack = () => {
        navigation.setOptions({
            gestureEnabled: false,
        })
    }
    const whereToHideNav = ROUTE_STYLES[route.name]?.hideNav || footerRoute === 'Gamification'
    useEffect(() => {
        try {
            if (whereToHideNav) {
                setShowNav(false)
                disableSwipeBack()
                setStatusBarColor('light-content')
            } else {
                setShowNav(true)
                setStatusBarColor('dark-content')
            }
            const handleBackButton = () => {
                if (route.name === 'Survey' || route.name === 'TriviaGame' || footerRoute === 'Gamification') {
                    return true // Prevent default back button behavior
                }
                return false // Allow default back button behavior
            }
            handleButtonsUpdate()
            mediaSingleton.pauseAllAudios()
            let listener
            if (Platform.OS !== 'web') {
                listener = BackHandler.addEventListener('hardwareBackPress', handleBackButton)
            }

            return () => {
                if (Platform.OS !== 'web') {
                    // En RN modernos, removeEventListener está deprecado. Usar el remove del listener.
                    try {
                        listener?.remove?.()
                    } catch {}
                }
            }
        } catch (error) {
            console.log('🚀 ~ useEffect appbAR ~ error:', error)
            console.error(error)
        }
    }, [route, customBack, footerRoute])

    const handleNavAndActions = () => {
        try {
            console.log('VALOR DE KEY => footerRoute', footerRoute)
            if (route.name === 'Survey' || route.name === 'TriviaGame' || footerRoute === 'Gamification') {
                setShowNav(false)
                disableSwipeBack()
                setStatusBarColor('light-content')
            } else {
                setShowNav(true)
                setStatusBarColor('dark-content')
            }
            const handleBackButton = () => {
                if (route.name === 'Survey' || route.name === 'TriviaGame' || footerRoute === 'Gamification') {
                    return true // Prevent default back button behavior
                }
                return false // Allow default back button behavior
            }
            handleButtonsUpdate()
            mediaSingleton.pauseAllAudios()
            let listener
            if (Platform.OS !== 'web') {
                listener = BackHandler.addEventListener('hardwareBackPress', handleBackButton)
            }

            return () => {
                if (Platform.OS !== 'web') {
                    try {
                        listener?.remove?.()
                    } catch {}
                }
            }
        } catch (error) {
            console.log('🚀 ~ useEffect appbAR ~ error:', error)
            console.error(error)
        }
    }

    const [downloadLoading, setDownloadLoading] = useState(false)

    useEffect(() => {
        const onStart = () => setDownloadLoading(true)
        const onEnd = () => setDownloadLoading(false)

        eventEmitter.on('start', onStart)
        eventEmitter.on('end', onEnd)

        eventEmitter.on('buttonsUpdated', handleButtonsUpdate)

        return () => {
            eventEmitter.removeListener('start', onStart)
            eventEmitter.removeListener('end', onEnd)
            eventEmitter.removeListener('buttonsUpdated', handleButtonsUpdate)
        }
    }, [])
    const iconColor = secondaryStyle ? 'white' : undefined

    const handleButtonsUpdate = async () => {
        try {
            const res_get_footer_app = await UserServices.getNavApp()
            if (res_get_footer_app && res_get_footer_app.length > 0) {
                setButtons(res_get_footer_app)
            }
        } catch (error) {
            console.log('error => ', error)
        }
    }
    const renderTab = (button) => {
        return (
            <TouchableOpacity key={button._id} onPress={() => navigation.navigate(button.label)} activeOpacity={1} style={styles.appBarIcons}>
                <Feather
                    name='calendar'
                    size={24}
                    color={route.name == button.label ? theme.colors.colorPrimary : !secondaryStyle ? iconColor : 'white'}
                />
            </TouchableOpacity>
        )
    }

    const getProgressTotal = async () => {
        let tablesPending = await UserServices.get_pendings_conections()

        // console.log('tablesPending => ', JSON.stringify(tablesPending))
        if (!tablesPending || !tablesPending?.results || Object.values(tablesPending.results).length == 0) {
            return 0
        }

        const cantPending = Object.values(tablesPending.results).reduce((acc, value) => {
            if (typeof value === 'number' && value > 0) {
                acc += value
            }
            return acc
        }, 0)

        // console.log('11cantPending => ', cantPending)

        return cantPending || 0
    }

    const handleIconPendingData = async () => {
        // console.log('-----------handleIconPendingData-------------')

        if (!isConnected || !hasInternet) {
            const message = 'No tenés conexión. Los formularios y visitas se enviarán automáticamente cuando estés nuevamente en línea.'
            setAlert(message, 'white', 'wifi-off', THEME_COLOR_ALERT.ERROR, true, false, 'Feather', 24)
            return
        }

        // Obtener el total si no existe
        if (progressTotalModal === 0) {
            const totalPendingsToSend = await getProgressTotal()
            setProgressTotalModal(totalPendingsToSend)
        }

        // Crear el alert con progreso en vivo
        const initialText = generateAlertText()
        setAlert(initialText, 'white', 'warning-outline', 'rgba(0, 0, 0, 0.8)', true, true, 'Ionicons', 28) // Usando Ionicons
    }

    const statusBarHeight = isAndroid() ? StatusBar.currentHeight : 0

    const isEntornoTest = isEntornoTesting() || slug == CLIENTS_SLUGS.DOTS_II
    const MainGradientColors = [AppGradientTheme.mainGradientStart, AppGradientTheme.mainGradientEnd]
    const SecondaryGradientColors = [AppGradientTheme.secondaryGradientStart, AppGradientTheme.secondaryGradientEnd]
    return (
        showNav && (
            //StatusBar
            <LinearGradient
                colors={!secondaryStyle ? MainGradientColors : SecondaryGradientColors}
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
                style={{
                    paddingTop: !secondaryStyle ? statusBarHeight : 0,
                }}
            >
                {/* Appbar */}
                <View style={!secondaryStyle ? styles.appBarParent : styles.appBarParentBenefits}>
                    <LinearGradient
                        style={{ ...styles.appBar }}
                        colors={!secondaryStyle ? MainGradientColors : SecondaryGradientColors}
                        start={{ x: 0, y: 0.5 }}
                        end={{ x: 1, y: 0.5 }}
                    >
                        <View style={styles.appBarLeft}>
                            {route.name !== 'Main' && (
                                <TouchableOpacity
                                    style={styles.arrow}
                                    onPress={() => {
                                        // Sincronizar footer y evitar GO_BACK no manejado
                                        setCurrentFooterRoute(prevFooterRoute)
                                        try {
                                            if (navigation.canGoBack && navigation.canGoBack()) {
                                                navigation.goBack()
                                            } else {
                                                navigation.reset?.({ index: 0, routes: [{ name: 'LearningHome' }] })
                                            }
                                        } catch (e) {
                                            try {
                                                navigation.navigate('LearningHome')
                                            } catch {}
                                        }
                                    }}
                                >
                                    <Ionicons name='arrow-back-outline' size={24} color={iconColor} />
                                </TouchableOpacity>
                            )}

                            {isEntornoTest ? (
                                <TouchableOpacity onPress={() => get_info()}>
                                    <Image
                                        key={iconColor}
                                        style={styles.appBarAvatar}
                                        source={AppBarTheme.navImage}
                                        tintColor={iconColor}
                                        resizeMode='contain'
                                    />
                                </TouchableOpacity>
                            ) : (
                                <TouchableOpacity
                                    onPress={() => {
                                        // Reabrir performance monitor si está cerrado (solo en DEV y si está habilitado)
                                        if (__DEV__ && PERFORMANCE_MONITOR_ENABLED) {
                                            eventEmitter.emit('reopenPerformanceMonitor')
                                        }
                                    }}
                                >
                                    <Image
                                        key={iconColor} // Se agrega key para forzar el cambio de color por el tinte
                                        style={styles.appBarAvatar}
                                        source={AppBarTheme.navImage}
                                        tintColor={iconColor}
                                        resizeMode='contain'
                                    />
                                </TouchableOpacity>
                            )}

                            {(!isConnected || !hasInternet) && (
                                <Image
                                    style={styles.wifi}
                                    source={require('../../../assets/no_wifi.png')}
                                    tintColor={!secondaryStyle ? theme.colors.error : 'white'}
                                />
                            )}

                            {locationLoaded === true && (userLat == null || userLat == 0) && (userLng == null || userLng == 0) && (
                                <Image
                                    style={styles.wifi}
                                    source={require('../../../assets/noLocation.png')}
                                    tintColor={!secondaryStyle ? theme.colors.error : 'white'}
                                />
                            )}
                        </View>
                        {route.name !== 'WebView' && (
                            <View style={styles.appBarRight}>
                                {isEntornoTest && (
                                    <TouchableOpacity onPress={() => goDatabase()} activeOpacity={0.6} style={[styles.appBarIcons]}>
                                        <Text style={{ color: iconColor }}>DB</Text>
                                    </TouchableOpacity>
                                )}

                                {havePendingData && (
                                    <TouchableOpacity onPress={() => handleIconPendingData()} activeOpacity={0.6} style={styles.appBarIcons}>
                                        <Feather name={'refresh-ccw'} size={24} color={!secondaryStyle ? theme.colors.error : 'white'} />
                                    </TouchableOpacity>
                                )}

                                <TouchableOpacity onPress={() => searchInTheApp()} activeOpacity={0.6} style={styles.appBarIcons}>
                                    <Feather name='search' size={24} color={iconColor} />
                                </TouchableOpacity>

                                {buttonsNav?.length > 0 && buttonsNav.map((tabButton) => renderTab(tabButton))}

                                {showProfileNav && (
                                    <TouchableOpacity onPress={() => goProfile()} activeOpacity={0.6} style={styles.appBarIcons}>
                                        <Feather
                                            name='settings'
                                            size={24}
                                            color={route.name === 'Profile' ? theme.colors.colorPrimary : !secondaryStyle ? iconColor : 'white'}
                                        />
                                    </TouchableOpacity>
                                )}

                                <TouchableOpacity onPress={() => handle_notification()} activeOpacity={0.6} style={styles.appBarIcons}>
                                    {/*{without_seeing && <Text>{without_seeing_total}</Text>}*/}
                                    {without_seeing ? (
                                        <Image
                                            source={
                                                !secondaryStyle
                                                    ? require('../../../assets/bellActive.png')
                                                    : require('../../../assets/bellActiveWhite.png')
                                            }
                                            style={styles.bell}
                                        />
                                    ) : (
                                        <Feather name='bell' size={24} color={iconColor} />
                                    )}
                                </TouchableOpacity>
                            </View>
                        )}

                        {route.name === 'WebView' && expoConfig.slug != 'jti-connect' && (
                            <>
                                {downloadLoading ? (
                                    <ActivityIndicator color={theme.colors.colorPrimary} size={24} />
                                ) : (
                                    <TouchableOpacity onPress={() => handleDownloadLink()}>
                                        <Feather name='download' size={24} color={iconColor} />
                                    </TouchableOpacity>
                                )}
                            </>
                        )}
                    </LinearGradient>
                </View>
            </LinearGradient>
        )
    )
}

export default AppBar
